import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
var _effectorFileName = "/builds/gmini/front-common/src/components/VersionSwitch/versionHistoryStore.ts";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.array.map.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { isNotEmpty } from '@gmini/utils';
import { createStore, createEvent, merge } from 'effector';
export function createVersionHistoryStore(_ref) {
  var fetchDates = _ref.fetchDates,
      fetchVersions = _ref.fetchVersions,
      fetchNamedVersionDates = _ref.fetchNamedVersionDates,
      fetchNamedVersions = _ref.fetchNamedVersions,
      versionNameChanged = _ref.versionNameChanged,
      changeStatusVersion = _ref.changeStatusVersion;
  var removeVersion = createEvent({
    name: "removeVersion",
    sid: "6pahbu"
  });
  var removeDate = createEvent({
    name: "removeDate",
    sid: "-5978iy"
  });
  var versionDates$ = createStore(null, {
    name: "versionDates$",
    sid: "dairef"
  }).on(merge([fetchDates, fetchNamedVersionDates], {
    name: "versionDates$",
    sid: "wjczv1"
  }), function (_, versionDates) {
    return versionDates && versionDates;
  }).on(removeDate, function (state, _ref2) {
    var versionDate = _ref2.versionDate;

    if (state) {
      return _objectSpread(_objectSpread({}, state), {}, {
        versionDates: state.versionDates.filter(function (date) {
          return date !== versionDate;
        })
      });
    }

    return state;
  });
  var versions$ = createStore(null, {
    name: "versions$",
    sid: "ydzjzn"
  }).on(fetchVersions, function (state, _ref3) {
    var versionDate = _ref3.versionDate,
        versions = _ref3.versions;

    if (state) {
      return _objectSpread(_objectSpread({}, state), {}, _defineProperty({}, versionDate, versions));
    }

    return _defineProperty({}, versionDate, versions);
  }).on(fetchNamedVersions, function (_, data) {
    return data.reduce(function (acc, next) {
      if (next) {
        return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, next.versionDate, next.versions));
      }

      return acc;
    }, {});
  }).on(merge([versionNameChanged, changeStatusVersion].filter(isNotEmpty), {
    name: "versions$",
    sid: "dhwv80"
  }), function (state, _ref5) {
    var version = _ref5.version,
        versionDate = _ref5.versionDate;

    if (state) {
      var currentVersions = state[versionDate];
      var index = currentVersions.findIndex(function (ver) {
        return ver.id === version.id;
      });
      return _objectSpread(_objectSpread({}, state), {}, _defineProperty({}, versionDate, currentVersions ? currentVersions.map(function (ver, i) {
        return index === i ? version : ver;
      }) : [version]));
    }

    return _defineProperty({}, versionDate, [version]);
  }).on(removeVersion, function (state, _ref7) {
    var version = _ref7.version,
        versionDate = _ref7.versionDate;

    if (state && state[versionDate]) {
      var versionArr = state[versionDate].filter(function (ver) {
        return ver.id !== version.id;
      });

      if (!versionArr.length) {
        var newState = _objectSpread({}, state);

        delete newState[versionDate];
        removeDate({
          versionDate: versionDate
        });
        return newState;
      }

      return _objectSpread(_objectSpread({}, state), {}, _defineProperty({}, versionDate, versionArr));
    }

    return state;
  });
  return {
    versions$: versions$,
    versionDates$: versionDates$,
    removeVersion: removeVersion
  };
}